var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
import { getShape, getColor, getBackgroundColor, getBorderColor } from '../util';
const SvgTamanhoGg = _a => {
  var {
      size,
      shape = 'circle',
      neutral = false
    } = _a,
    props = __rest(_a, ["size", "shape", "neutral"]);
  const backgroundColor = getBackgroundColor(shape, neutral);
  const color = getColor(shape, neutral);
  const borderColor = getBorderColor(neutral);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size !== null && size !== void 0 ? size : 96,
    height: size !== null && size !== void 0 ? size : 96,
    fill: "none",
    viewBox: "0 0 96 96"
  }, props), getShape(shape, backgroundColor), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M62.204 49.648h13.219M66.053 49.359V46.6M71.571 49.359V46.6"
  }), React.createElement("path", {
    fill: color,
    stroke: borderColor,
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M88.802 23.414h-39.98c-.564 0-1.022.428-1.022.955V45.05c0 .528.458.956 1.023.956h39.98c.565 0 1.023-.428 1.023-.956V24.37c0-.528-.458-.956-1.024-.956Z"
  }), React.createElement("path", {
    stroke: "var(--color-neutral-70)",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "m59.346 40.038 21.242-9.301M59.346 35.388l13.656-6.201"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    d: "M36.515 25.52c4.431 5.187 3.768 9.356-2.38 12.514-6.713 3.45-3.134 10.192-8.782 15.002-5.386 4.584-12.16-.97-15.149-3.969-2.988-2.999-8.539-9.778-3.962-15.172 4.802-5.657 11.534-2.067 14.979-8.797 3.152-6.162 7.321-6.82 12.494-2.383"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M36.515 25.52c4.431 5.187 3.768 9.356-2.38 12.514-6.713 3.45-3.134 10.192-8.782 15.002-5.386 4.584-12.16-.97-15.149-3.969-2.988-2.999-8.539-9.778-3.962-15.172 4.802-5.657 11.534-2.067 14.979-8.797 3.152-6.162 7.321-6.82 12.494-2.383"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    d: "m32.18 30.22 11.193-12.162c.651-.707 1.576-.97 2.428-1.408 2.21-1.14 4.346-2.505 6.67-4.834 1.553-1.554-.097-3.011-1.083-3.999-.986-.987-2.44-2.64-3.992-1.085-2.331 2.335-3.688 4.468-4.827 6.681-.438.854-.706 1.786-1.406 2.432l-12.141 11.21"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m32.18 30.22 11.193-12.162c.651-.707 1.576-.97 2.428-1.408 2.21-1.14 4.346-2.505 6.67-4.834 1.553-1.554-.097-3.011-1.083-3.999-.986-.987-2.44-2.64-3.992-1.085-2.331 2.335-3.688 4.468-4.827 6.681-.438.854-.706 1.786-1.406 2.432l-12.141 11.21"
  }), React.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m47.944 15.985.384.47M50.379 14.157l.383.476M52.808 12.335l.383.469M42.905 11.548l-.468-.384M44.73 9.11l-.474-.384M46.551 6.677l-.468-.384"
  }), React.createElement("path", {
    fill: "var(--color-neutral-80)",
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M28.98 37.15a4.877 4.877 0 0 0 0-6.889 4.858 4.858 0 0 0-6.878 0 4.877 4.877 0 0 0 0 6.889 4.858 4.858 0 0 0 6.877 0Z"
  }), React.createElement("path", {
    fill: color,
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m13.628 38.176-.743.745c-.094.094-.05.29.098.438l6.912 6.924c.148.148.344.192.438.098l.743-.745c.094-.094.05-.29-.097-.438l-6.913-6.924c-.148-.148-.344-.192-.438-.098Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M39.808 79.535c.842-5.222-2.68-10.143-7.867-10.99-5.187-.848-10.075 2.698-10.916 7.92-.842 5.222 2.68 10.143 7.867 10.99 5.187.848 10.074-2.698 10.916-7.92Z"
  }), React.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M47.153 76.47 60.981 66.1M60.983 62.643H41.537L29.87 77.98l12.805.218M43.698 76.47 40.24 57.457"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M75.014 79.535c.842-5.222-2.68-10.143-7.867-10.99-5.187-.848-10.075 2.698-10.916 7.92-.842 5.222 2.68 10.143 7.867 10.99 5.187.848 10.074-2.698 10.916-7.92Z"
  }), React.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M66.168 78.199C57.45 62.8 65.856 51.63 55.798 54.43"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M48.882 77.335a2.593 2.593 0 1 0-5.186 0 2.593 2.593 0 0 0 5.186 0ZM38.51 57.457h5.186M43.696 79.927l-.864 3.457h-.864M45.426 74.741l1.73-1.728h1.727"
  }), React.createElement("path", {
    stroke: "var(--color-neutral-90)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M71.354 74.742c-.958-1.75-2.871-3.059-5.186-3.457M59.253 78.198a6.914 6.914 0 0 0 6.914 6.914M28.141 71.285c-2.043 1.222-3.457 3.858-3.457 6.914M29.87 85.112c2 0 3.82-.655 5.185-1.728"
  }));
};
export default SvgTamanhoGg;